import ApiHandler from '@/api/base'

class SSOApiHandler extends ApiHandler {
  async getSSO() {
    const { data } = await this.http.get('/sso')

    return data
  }

  async createSamlConnection({
    ssoEndpoint = null,
    certificate = null,
    name,
    provider,
    domains = []
  } = {}) {
    const { data } = await this.http.post('/sso/saml/manual', {
      name,
      ssoEndpoint,
      certificate,
      provider,
      domains
    })
    return data
  }

  async validateDomainsAvailabilityForSaml({ domains = [] } = {}) {
    const { data } = await this.http.post('/sso/domains/validateAvailability', {
      domains
    })

    return data
  }

  async addCertificateToSamlConnection({
    id,
    certificate = '',
    ssoEndpoint = '',
    issuer = ''
  } = {}) {
    const { data } = await this.http.put(`/sso/${id}`, {
      certificate,
      ssoEndpoint,
      issuer
    })

    return data
  }

  async activateSamlConnection(id) {
    const { data } = await this.http.post(`/sso/${id}/activate`)

    return data
  }

  async createScimConnection({ name, provider }) {
    const { data } = await this.http.post('/scim', {
      name,
      provider
    })
    return data
  }

  async updateSamlConnectionName({ name, id }) {
    const { data } = await this.http.put(`/sso/${id}/name`, {
      name
    })
    return data
  }

  async updateScimConnectionName({ name, id }) {
    const { data } = await this.http.put(`/scim/${id}`, {
      name
    })
    return data
  }

  async deleteSamlConnection({ id }) {
    const { data } = await this.http.delete(`/sso/${id}`)
    return data
  }

  async deleteScimConnection({ id }) {
    const { data } = await this.http.delete(`/scim/${id}`)
    return data
  }
}

export default SSOApiHandler
